// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"e1c63587","433":"beb082fa","774":"133316dc"}[chunkId] + ".chunk.css";
};